import React from 'react';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import classNames from 'classnames';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import role from 'shared/lib/role';

import ConfirmActions from 'flux/actions/ConfirmActions';
import MessageConstants from 'shared/constants/Messages';

/**
 * Lock
 *
 */
export default React.createClass({
  displayName: 'Lock',

  propTypes: {
    user: React.PropTypes.object,
    item: React.PropTypes.any.isRequired,
    isLocked: React.PropTypes.bool,
    rowIndex: React.PropTypes.number.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    let { isLocked } = this.props;

    let iconName = isLocked ? 'lock' : 'unlock';

    let classes = classNames('cs-row-lock', 'pointer', {
      'cs-row-lock-locked': isLocked,
      'cs-row-lock-unlocked': !isLocked,
    });

    //Prevent non admins from seeing unlock icon
    if (!isLocked && !this._hasEventAdminRole()) return null;

    return (
      <div className={classes} onClick={() => this._handleClick(isLocked)}>
        <Icon name={iconName} size={2} />
      </div>
    );
  },

  _handleClick(isLocked) {
    if (!this._hasEventAdminRole()) return;

    let confirmMessage = MessageConstants.lockRowLocked;

    if (isLocked) confirmMessage = MessageConstants.lockRowUnlocked;

    ConfirmActions.prompt(confirmMessage, () =>
      CuesheetRowActions.toggleRowLock(this.props.rowIndex),
    );
  },

  _hasEventAdminRole() {
    let { teamId, eventId } = this.context.router.state.params;
    return role.hasEventAdminRole(this.props.user, teamId, eventId);
  },
});
